"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("@aperza/fabric");
var CreateDate_1 = require("./CreateDate");
exports.createTextBox = function (text, width) {
    if (width === void 0) { width = 200; }
    return new fabric_1.fabric.Textbox(text, { fontSize: 16, width: width, splitByGrapheme: true });
};
exports.createSetPhraseTextBoxForButton = function (text, width) {
    return new fabric_1.fabric.Textbox(text, {
        fontSize: 12,
        width: width,
        editable: false,
        splitByGrapheme: true,
        fontWeight: '800',
    });
};
exports.createSetPhraseTextBox = function (text, width) {
    return new fabric_1.fabric.Textbox(text, {
        fontSize: 12,
        width: width,
        editable: true,
        splitByGrapheme: true,
    });
};
exports.createSetPhraseForButton = function (text) {
    var textboxObject = exports.createSetPhraseTextBoxForButton(text, 250);
    return textboxObject;
};
exports.createSetPhrase = function (text) {
    var textboxObject = exports.createSetPhraseTextBox(text, 250);
    return textboxObject;
};
exports.createTextBoxButton = function () {
    return new fabric_1.fabric.Text('T', { fontSize: 42, width: 200 });
};
exports.createShape = function () {
    return new fabric_1.fabric.Circle({ radius: 30, fill: '#f55' });
};
exports.createUnknown = function () {
    return new fabric_1.fabric.Circle({ radius: 30, fill: '#f55' });
};
exports.createSvg = function (imageUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var firstFabric;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    return fabric_1.fabric.loadSVGFromURL(imageUrl, function (objects, options) {
                        var obj = fabric_1.fabric.util.groupSVGElements(objects, options);
                        resolve(obj);
                    });
                })];
            case 1:
                firstFabric = _a.sent();
                return [2 /*return*/, firstFabric];
        }
    });
}); };
exports.createImage = function (imageUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var firstFabric, canvasElement, dataURL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    return fabric_1.fabric.Image.fromURL(imageUrl, resolve, {
                        crossOrigin: 'anonymous',
                    });
                })];
            case 1:
                firstFabric = _a.sent();
                canvasElement = firstFabric.toCanvasElement();
                dataURL = canvasElement.toDataURL();
                return [4 /*yield*/, new Promise(function (resolve) { return fabric_1.fabric.Image.fromURL(dataURL, resolve); })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// export interface ImageStampProps {
//   imageUrl: string;
// }
exports.styleFabricObject = function (_fabricObject, options) {
    if (options === void 0) { options = {}; }
    if (!_fabricObject)
        return;
    _fabricObject.lockScalingFlip = true;
    _fabricObject.borderColor = '#1274D7';
    _fabricObject.cornerColor = 'white';
    _fabricObject.cornerStrokeColor = '#1274D7';
    _fabricObject.transparentCorners = false;
    _fabricObject.cornerSize = 10;
    _fabricObject.borderScaleFactor = 3;
    _fabricObject.borderDashArray = [6];
    // _fabricObject.lockUniScaling = false;
    _fabricObject.set(options);
    exports.styleOptions = __assign(__assign({}, exports.styleOptions), options); // add options to list of properties we will copy over.  We are only interested in the keys.
};
exports.styleOptions = {
    lockScalingFlip: 'clone me',
    borderColor: 'clone me',
    cornerColor: 'clone me',
    cornerStrokeColor: 'clone me',
    transparentCorners: 'clone me',
    cornerSize: 'clone me',
    borderScaleFactor: 'clone me',
    borderDashArray: 'clone me',
    editable: 'clone me',
}; // list of options we will copy over when cloning.  We only use the keys, not the values
exports.renderStamp = function (stamp, options, forButton) { return __awaiter(void 0, void 0, void 0, function () {
    var asyncStamp, _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                asyncStamp = exports.createUnknown();
                _a = stamp.type;
                switch (_a) {
                    case 'shape': return [3 /*break*/, 1];
                    case 'textbox': return [3 /*break*/, 2];
                    case 'setPhrase': return [3 /*break*/, 3];
                    case 'image': return [3 /*break*/, 4];
                    case 'svg': return [3 /*break*/, 8];
                    case 'date': return [3 /*break*/, 12];
                }
                return [3 /*break*/, 13];
            case 1:
                asyncStamp = exports.createShape();
                return [3 /*break*/, 14];
            case 2:
                if (forButton) {
                    asyncStamp = exports.createTextBoxButton();
                }
                else {
                    asyncStamp = exports.createTextBox('');
                }
                return [3 /*break*/, 14];
            case 3:
                if (forButton) {
                    asyncStamp = stamp.text
                        ? exports.createSetPhraseForButton(stamp.text)
                        : exports.createSetPhraseForButton('');
                }
                else {
                    asyncStamp = stamp.text ? exports.createSetPhrase(stamp.text) : exports.createSetPhrase('');
                }
                return [3 /*break*/, 14];
            case 4:
                if (!stamp.imageUrl) return [3 /*break*/, 6];
                return [4 /*yield*/, exports.createImage(stamp.imageUrl)];
            case 5:
                _b = _d.sent();
                return [3 /*break*/, 7];
            case 6:
                _b = exports.createUnknown();
                _d.label = 7;
            case 7:
                asyncStamp = _b;
                return [3 /*break*/, 14];
            case 8:
                if (!stamp.imageUrl) return [3 /*break*/, 10];
                return [4 /*yield*/, exports.createSvg(stamp.imageUrl)];
            case 9:
                _c = _d.sent();
                return [3 /*break*/, 11];
            case 10:
                _c = exports.createUnknown();
                _d.label = 11;
            case 11:
                asyncStamp = _c;
                return [3 /*break*/, 14];
            case 12:
                asyncStamp = CreateDate_1.createDate(stamp.options);
                return [3 /*break*/, 14];
            case 13:
                asyncStamp = exports.createUnknown();
                return [3 /*break*/, 14];
            case 14:
                exports.styleFabricObject(asyncStamp, options);
                return [2 /*return*/, asyncStamp];
        }
    });
}); };
exports.cloneFabricObject = function (fabricObject) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                fabricObject.clone(function (clone) { return resolve(clone); }, Object.keys(exports.styleOptions));
            })];
    });
}); };
//# sourceMappingURL=CreateStamp.js.map